export default __webpack_public_path__ + "static/media/info-button-light.050063a1.svg";